import { useStripePayment } from "./useStripePayment";
import { usePayPayPayment } from "./usePayPayPayment";

interface UsePaymentHandlingReturn {
  isLoadingPurchase: boolean;
  isShownModalCompleted: boolean;
  setIsShownModalCompleted: (value: boolean) => void;
}

export function usePaymentHandling(
  finishedFetch: boolean,
  refreshContents: () => Promise<void>,
): UsePaymentHandlingReturn {
  const { isLoadingStripe, isStripeCompleted, setIsStripeCompleted } =
    useStripePayment(finishedFetch, refreshContents);

  const { isLoadingPayPay, isPayPayCompleted, setIsPayPayCompleted } =
    usePayPayPayment(refreshContents);

  // 統合された状態を返す
  const isLoadingPurchase = isLoadingStripe || isLoadingPayPay;
  const isShownModalCompleted = isStripeCompleted || isPayPayCompleted;

  const setIsShownModalCompleted = (value: boolean) => {
    setIsStripeCompleted(value);
    setIsPayPayCompleted(value);
  };

  return {
    isLoadingPurchase,
    isShownModalCompleted,
    setIsShownModalCompleted,
  };
}
